import {observer} from "mobx-react";
import {
    AppBar,
    Box,
    IconButton, SwipeableDrawer,
    Toolbar,
    useMediaQuery,
    useTheme
} from "@mui/material";
import NavBar from "../NavBar/NavBar";
import piginiSmallLogo from '../../assets/img/pigin_logo_without_text.jpeg'
import excelsiorSmallLogo from '../../assets/img/excelsior_logo_without_text.png'
import React, {useState} from "react";
import MenuIcon from '@mui/icons-material/Menu'
import {useNavigate} from "react-router-dom";
import RollingCredits from "../RollingCredits/RollingCredits";

export default observer(function ResponsiveToolbar(){
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))
    const navigate = useNavigate();

    const [drawerState, setDrawerState] = useState<boolean>(false);
    const anchor = 'left'
    const toggleDrawer = () => {
        setDrawerState(!drawerState);
    }
    const handleClose = () => {
        setDrawerState(false)
    }
    const handleOpen = () => {
        setDrawerState(true)
    }

    const renderLargeScreen = () =>
        <>
            <img src={piginiSmallLogo} style={{width: '60px', height: '60px', marginTop: '8px', borderRadius: '6px'}} />
            <Box sx={{ml: 'auto'}}>
                <NavBar mobile={false} />
            </Box>
            <img src={excelsiorSmallLogo} style={{width: '60px', height: '60px' , marginTop: '8px', marginLeft: 'auto', borderRadius: '50%'}} />
        </>

    const renderSmallScreen = () =>
        <Box display={'flex'} sx={{width: '100%'}}>
            <IconButton onClick={toggleDrawer}>
                <MenuIcon />
            </IconButton>
            <SwipeableDrawer
                anchor={anchor}
                open={drawerState}
                onClose={handleClose}
                onOpen={handleOpen}
            >
                <NavBar mobile={true} clickCallback={handleClose} />
            </SwipeableDrawer>
            <Box sx={{marginLeft: 'auto'}}>
                <img src={piginiSmallLogo} alt={'piginiSmallLogo'} style={{width: '50px'}} onClick={() => navigate('/')} />
            </Box>
        </Box>

    return (
        <AppBar position={'sticky'} color={'default'}>
            <Toolbar sx={{ }}>
                <Box display={'flex'} sx={{width: '100%', marginTop: '16px'}}>
                    { isLargeScreen ? renderLargeScreen() : renderSmallScreen() }
                </Box>
            </Toolbar>
            <RollingCredits />
        </AppBar>
    )
})